import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }

  showResponse(resp) {
    Swal.fire({
      icon: resp.type,
      title: resp.type === 'success' ? '¡Éxito!' : '¡Error!',
      text: resp.message,
      confirmButtonText: 'Aceptar'
    });
  }

  showLoading() {
    Swal.showLoading();
  }

  showLoadingText() {
    Swal.fire({
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    Swal.showLoading();
  }
}
